import React from 'react';

const ArrowDownIcon = ({ width = 24, height = 24, fill = "#ffffff" }) => (
    <svg
        viewBox="0 -4.5 20 20"
        xmlns="http://www.w3.org/2000/svg"
        fill={fill}
        width={width}
        height={height}
    >
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
            <title>arrow_down [#336]</title>
            <desc>Created with Sketch.</desc>
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Dribbble-Light-Preview" transform="translate(-260.000000, -6684.000000)" fill={fill}>
                    <g id="icons" transform="translate(56.000000, 155.000000)">
                        <path d="M223.707692,6533.16951 C224.097436,6533.57338 224.097436,6534.22888 223.707692,6534.63378 L215.444127,6543.19672 C214.66364,6544.00548 213.397472,6544.00548 212.616986,6543.19672 L204.29246,6534.57164 C203.906714,6534.17089 203.901717,6533.52367 204.282467,6533.11774 C204.671211,6532.70249 205.31179,6532.69835 205.70653,6533.10635 L213.323521,6541.00033 C213.714264,6541.40523 214.346848,6541.40523 214.737591,6541.00033 L222.294621,6533.16951 C222.684365,6532.76461 223.317949,6532.76461 223.707692,6533.16951" id="arrow_down-[#336]"></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export default ArrowDownIcon;
